import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import {
    ExpandableComponent,
    HtmlEscapePipe,
    KeywordItemComponent,
    KeywordsComponent,
} from '@exl-ng/mulo-common';
import { DefaultTranslatePipe } from '../../../shared/pipes/default-translate.pipe';

enum Sections {
    KEYWORDS = 'keywords',
    SUBJECTESPLORO = 'subjectEsploro',
    DESCRIPTIONABSTRACT = 'descriptionAbstract',
}

@Component({
    selector: 'esp-description-and-keywords',
    templateUrl: './description-and-keywords.component.html',
    styleUrls: ['./description-and-keywords.component.scss'],
    imports: [
        KeywordsComponent,
        KeywordItemComponent,
        ExpandableComponent,
        TranslateModule,
        HtmlEscapePipe,
        DefaultTranslatePipe,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DescriptionAndKeywordsComponent {
    readonly description = input<string>(undefined);
    readonly researchTopics = input<string[]>([]);
    readonly researchKeywords = input<string[]>([]);
    readonly sectionOrder = input([]);

    readonly orderedActiveSections = computed(() =>
        this.sectionOrder()
            .filter((section) => section.active)
            .map((section) => section.code),
    );

    readonly isTopicsSeparate = computed(
        () =>
            this.orderedActiveSections()?.length === 3 &&
            this.orderedActiveSections()[1] === Sections.DESCRIPTIONABSTRACT,
    );
    readonly isDescriptionAbstractFirst = computed(
        () =>
            this.orderedActiveSections()?.length &&
            this.orderedActiveSections()[0] === Sections.DESCRIPTIONABSTRACT,
    );
    readonly isKeywordsFirst = computed(
        () =>
            this.orderedActiveSections().length > 1 &&
            this.orderedActiveSections().indexOf(Sections.KEYWORDS) <
                this.orderedActiveSections().indexOf(Sections.SUBJECTESPLORO),
    );

    readonly concatTopicList = computed(() =>
        this.isKeywordsFirst()
            ? this.researchKeywords().concat(this.researchTopics())
            : this.researchTopics().concat(this.researchKeywords()),
    );

    readonly topicsList = computed(() => {
        if (!this.isTopicsSeparate()) {
            return this.isDescriptionAbstractFirst()
                ? []
                : this.concatTopicList();
        } else {
            return this.isKeywordsFirst()
                ? this.researchKeywords()
                : this.researchTopics();
        }
    });

    readonly keywordsList = computed(() => {
        if (!this.isTopicsSeparate()) {
            return this.isDescriptionAbstractFirst()
                ? this.concatTopicList()
                : [];
        } else {
            return this.isKeywordsFirst()
                ? this.researchTopics()
                : this.researchKeywords();
        }
    });
}
